

export interface StandardFormType<T = any> {
  value?: T;
  defaultValue?: T;
  onChange?: (values: T) => void;
}

export enum MatchMode {
  // 同时匹配
  ANDMATCH = 'ANDMATCH',
  // 质量包含
  CONTAIN = 'CONTAIN',
  // 质量不包含
  NOTCONTAIN = 'NOTCONTAIN',
  // 质量是
  Is = 'IS',
  // 质量不是
  ISNOT = 'ISNOT',
  // 小于
  Lt = 'LT',
  // 小于等于
  Le = 'LE',
  // 大于
  Gt = 'GT',
  // 大于等于
  Ge = 'GE',
  // 等于
  Eq = 'OR',
  Between = 'BETWEEN',
  // 性能是
  OR = 'OR',
  // 性能不是
  NOT = 'NOT',
  // 必须要满足所有的 Filter values，仅提供给启动指标的[自定义tag]使用
  AND = 'AND',
  // 模糊匹配
  LIKEARRAY = 'LIKEARRAY',
  // 中间匹配
  MIDMATCH = 'MIDMATCH',
  // 性能包含
  MATCH = 'MATCH',
  // 性能不包含
  NOTMATCH = 'NOTMATCH',
  PREFIX = 'PREFIX',
  SUFFIX = 'SUFFIX',
  EXACT = 'EXACT',
  BitOr = 'bitOr',
  BitAnd = 'bitAnd',
  ISEMPTY = 'ISEMPTY',
  NOTEMPTY = 'NOTEMPTY',
  NOTPREFIX = 'NOTPREFIX',
  NOTSUFFIX = 'NOTSUFFIX',
  REGEXP = 'REGEXP',
  REGEXPFAIL = 'REGEXPFAIL',
  // 出错堆栈分词
  TOKENIZATION = 'TOKENIZATION',
  NOTTOKENIZATION = 'NOTTOKENIZATION',
}

export const MATCH_MODE_TEXT: Record<string, string> = {
  [MatchMode.SUFFIX]: '开头匹配',
  [MatchMode.PREFIX]: '结尾匹配',
  [MatchMode.CONTAIN]: '匹配',
  [MatchMode.NOTCONTAIN]: '不匹配',
  [MatchMode.Is]: '是',
  [MatchMode.ISNOT]: '不是',
  [MatchMode.MATCH]: '匹配',
  [MatchMode.NOTMATCH]: '不匹配',
  [MatchMode.Lt]: '小于',
  [MatchMode.Le]: '小于等于',
  [MatchMode.NOT]: '不等于',
  [MatchMode.Gt]: '大于',
  [MatchMode.Ge]: '大于等于',
  [MatchMode.Eq]: '等于',
  [MatchMode.Between]: '区间',
  [MatchMode.OR]: '是',
  [MatchMode.NOT]: '不是',
  [MatchMode.LIKEARRAY]: '模糊匹配',
  [MatchMode.MIDMATCH]: '中间匹配',
  [MatchMode.NOTEMPTY]: '不为空',
  [MatchMode.ISEMPTY]: '为空',
  [MatchMode.NOTPREFIX]: '开头不匹配',
  [MatchMode.NOTSUFFIX]: '结尾不匹配',
  [MatchMode.REGEXP]: '正则表达式',
  [MatchMode.ANDMATCH]: '同时匹配',
  [MatchMode.TOKENIZATION]: '分词',
};

export const ENUM_MATCH_OPTIONS = [
  {
    value: MatchMode.OR,
    label: '是',
  },
  {
    value: MatchMode.NOT,
    label: '不是',
  },
];

/**
 * 版本匹配模式
 */
export const VERSION_MATCH_OPTIONS = [
  {
    value: MatchMode.OR,
    label: '是',
  },
  {
    value: MatchMode.NOT,
    label: '不是',
  },
  {
    value: MatchMode.Gt,
    label: '大于',
  },
  {
    value: MatchMode.Ge,
    label: '大于等于',
  },
  {
    value: MatchMode.Lt,
    label: '小于',
  },
  {
    value: MatchMode.Le,
    label: '小于等于',
  },
  {
    value: MatchMode.Between,
    label: '区间',
  },
  {
    value: MatchMode.MATCH,
    label: '匹配',
  },
  {
    value: MatchMode.NOTMATCH,
    label: '不匹配',
  },
  {
    value: MatchMode.ISEMPTY,
    label: '为空',
  },
  {
    value: MatchMode.NOTEMPTY,
    label: '不为空',
  },
  {
    value: MatchMode.PREFIX,
    label: '开头匹配',
  },
  {
    value: MatchMode.NOTPREFIX,
    label: '开头不匹配',
  },
  {
    value: MatchMode.SUFFIX,
    label: '结尾匹配',
  },
  {
    value: MatchMode.NOTSUFFIX,
    label: '结尾不匹配',
  },
  {
    value: MatchMode.REGEXP,
    label: '正则表达式',
  },
];

/**
 * 数值匹配模式
 */
export const NUMBER_MATCH_OPTIONS = [
  {
    value: MatchMode.Gt,
    label: '大于',
  },
  {
    value: MatchMode.Ge,
    label: '大于等于',
  },
  {
    value: MatchMode.Eq,
    label: '等于',
  },
  {
    value: MatchMode.NOT,
    label: '不等于',
  },
  {
    value: MatchMode.Lt,
    label: '小于',
  },
  {
    value: MatchMode.Le,
    label: '小于等于',
  },
  {
    value: MatchMode.Between,
    label: '区间',
  },
];

export const STRING_ARRAY_MATCH_OPTIONS = [
  {
    value: MatchMode.MATCH,
    label: '不匹配',
  },
  {
    value: MatchMode.NOTMATCH,
    label: '匹配',
  },
  {
    value: MatchMode.LIKEARRAY,
    label: '模糊匹配',
  },
];

/**
 * 字符串匹配模式
 */
export const CHARACTER_MATCH_OPTIONS = [
  {
    value: MatchMode.OR,
    label: '是',
  },
  {
    value: MatchMode.NOT,
    label: '不是',
  },
  {
    value: MatchMode.MATCH,
    label: '匹配',
  },
  {
    value: MatchMode.NOTMATCH,
    label: '不匹配',
  },
  {
    value: MatchMode.ANDMATCH,
    label: '同时匹配',
  },
  {
    value: MatchMode.ISEMPTY,
    label: '为空',
  },
  {
    value: MatchMode.NOTEMPTY,
    label: '不为空',
  },
  {
    value: MatchMode.PREFIX,
    label: '开头匹配',
  },
  {
    value: MatchMode.NOTPREFIX,
    label: '开头不匹配',
  },
  {
    value: MatchMode.SUFFIX,
    label: '结尾匹配',
  },
  {
    value: MatchMode.NOTSUFFIX,
    label: '结尾不匹配',
  },
  {
    value: MatchMode.REGEXP,
    label: '正则匹配',
  },
  {
    value: MatchMode.REGEXPFAIL,
    label: '正则不匹配',
  },
];


/**
 * 堆栈字符串匹配模式(新增分词匹配规则)
 */
export const STACK_CHARACTER_MATCH_OPTIONS = [
  {
    value: MatchMode.TOKENIZATION,
    label: '分词',
  },
  {
    value: MatchMode.NOTTOKENIZATION,
    label: '分词不匹配',
  },
  {
    value: MatchMode.MATCH,
    label: '匹配',
  },
  {
    value: MatchMode.NOTMATCH,
    label: '不匹配',
  },
  {
    value: MatchMode.OR,
    label: '是',
  },
  {
    value: MatchMode.NOT,
    label: '不是',
  },
  {
    value: MatchMode.ANDMATCH,
    label: '同时匹配',
  },
  {
    value: MatchMode.ISEMPTY,
    label: '为空',
  },
  {
    value: MatchMode.NOTEMPTY,
    label: '不为空',
  },
  {
    value: MatchMode.PREFIX,
    label: '开头匹配',
  },
  {
    value: MatchMode.NOTPREFIX,
    label: '开头不匹配',
  },
  {
    value: MatchMode.SUFFIX,
    label: '结尾匹配',
  },
  {
    value: MatchMode.NOTSUFFIX,
    label: '结尾不匹配',
  },
  {
    value: MatchMode.REGEXP,
    label: '正则匹配',
  },
  {
    value: MatchMode.REGEXPFAIL,
    label: '正则不匹配',
  },
];

/**
 * 字符串数组匹配模式
 */
export const CHARACTER_MATCH_ARRAY_OPTIONS = [
  {
    value: MatchMode.OR,
    label: '包含',
  },
  {
    value: MatchMode.NOT,
    label: '不包含',
  },
  {
    value: MatchMode.AND,
    label: '同时包含',
  },
  {
    value: MatchMode.MATCH,
    label: '匹配',
  },
  {
    value: MatchMode.ANDMATCH,
    label: '同时匹配',
  },
  {
    value: MatchMode.ISEMPTY,
    label: '为空',
  },
  {
    value: MatchMode.NOTEMPTY,
    label: '不为空',
  },
  {
    value: MatchMode.PREFIX,
    label: '开头匹配',
  },
  {
    value: MatchMode.SUFFIX,
    label: '结尾匹配',
  },
];


// 特定类型

export const SPECIFIC_TYPE = [
  { value: MatchMode.OR, label: 'OR' },
  { value: MatchMode.AND, label: 'AND' },
  { value: MatchMode.NOT, label: 'NOT' },
];

// 数据标记特殊类型
export const INFERRED_LABELS_OPTIONS = [
  {
    value: MatchMode.OR,
    label: '包含',
  },
  {
    value: MatchMode.NOT,
    label: '不包含',
  },
  {
    value: MatchMode.AND,
    label: '同时包含',
  },
];


export const TEXT_MATCH_OPTIONS = [
  {
    value: MatchMode.MATCH,
    label: '匹配',
  }];
